import {Vue} from 'ui.vue';

export let FavoritesLine = {
	store: BX.Citrus.Vuex.store,
	name: 'FavoritesLine',
	data: function () {
		return {
			loading: false
		};
	},
	computed: {
		loc: () => Object.freeze(Vue.getFilteredPhrases("TPL_PRODUCT_FAVORITES_")),

		productCount: function () {
			return this.$store.getters['favorites/count'];
		}
	},
	created: function () {
		if(!this.$store.getters['favorites/count'])
		{
			this.$store.dispatch('favorites/load');
		}

		Vue.event.$on("Citrus.Vue.Favorites:refresh", () => {});
	},
	beforeDestroy() {
		Vue.event.$off("Citrus.Vue.Favorites:refresh");
	},

};

export default {FavoritesLine};